/**
 * BOM detail／list item 讀取正規化。
 * Wire：`groups[].mtrs`／`extraMtrs`；舊 `materials`／`extraMaterials` 僅作讀取 alias。
 * 不反向把舊 key 寫回 API（寫入走 `buildBomWritePayload`）。
 */

function normalizeGroup(group) {
  if (!group || typeof group !== 'object') {
    return group;
  }
  const mtrs = group.mtrs ?? group.materials ?? [];
  return {
    ...group,
    mtrs,
    // 舊 UI／工單 bomSnapshot 可能仍讀 materials
    materials: group.materials ?? mtrs,
  };
}

export function normalizeBomWire(item) {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const groups = Array.isArray(item.groups)
    ? item.groups.map(normalizeGroup)
    : item.groups;
  const extraMtrs = item.extraMtrs ?? item.extraMaterials ?? [];

  return {
    ...item,
    groups,
    extraMtrs,
    extraMaterials: item.extraMaterials ?? extraMtrs,
  };
}

export function normalizeBomWireList(items = []) {
  return (items ?? []).map(normalizeBomWire);
}
